import api from '@/api/axios';

const state = {
  qalist: [],
  qaDetail: null, // 개별 상세 데이터를 저장할 상태 추가
  qaComment: null,
  isLoading: false,
  error: null,
};

const mutations = {
  SET_QALIST(state, qalist) {
    state.qalist = qalist;
  },
  SET_QA_DETAIL(state, qaDetail) {
    state.qaDetail = qaDetail;
  },
  SET_QA_COMMENT(state, qaComment) {
    state.qaComment = qaComment;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  ADD_QALIST(state, qalist) {
    state.qalist.push(qalist);
  },
  ADD_QA_COMMENT(state, qaComment) {
    state.qalist.push(qaComment);
  },
};

const actions = {
  // 전체 QA 목록 가져오기
  async fetchQaList({ commit, rootState }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/communication/qa_list`);
      console.log('response', response.data);
      commit('SET_QALIST', response.data);
    } catch (error) {
      console.error('Failed to fetch QA list:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch QA list');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 특정 QA 상세 조회
  async fetchQaDetail({ commit, rootState }, qa_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/communication/qa_detail/${qa_id}`);
      console.log(`QA Detail (qa_id: ${qa_id})`, response.data);
      commit('SET_QA_DETAIL', response.data);
    } catch (error) {
      console.error(`Failed to fetch QA detail (qa_id: ${qa_id}):`, error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || `Failed to fetch QA detail (qa_id: ${qa_id})`);
    } finally {
      commit('SET_LOADING', false);
    }
  },
 
  // 특정 QA comment 조회
  async fetchQaComment({ commit, rootState }, qa_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/communication/qa_comment/${qa_id}`);
      console.log(`QA Detail (qa_id: ${qa_id})`, response.data);
      commit('SET_QA_COMMENT', response.data);
    } catch (error) {
      console.error(`Failed to fetch QA detail (qa_id: ${qa_id}):`, error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || `Failed to fetch QA detail (qa_id: ${qa_id})`);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // QA 생성하기
  async createQaList({ commit, rootState }, qaListData) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      console.log(qaListData);
      const response = await api.post(`/api/v1/communication/saveQaList`, qaListData);
      commit('ADD_QALIST', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create QA:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        commit('SET_ERROR', `Failed to create QA: ${JSON.stringify(error.response.data)}`);
      } else {
        commit('SET_ERROR', error.message || 'Failed to create QA');
      }
      return {
        success: false,
        error: error.response ? error.response.data : (error.message || 'Failed to create QA')
      };
    } finally {
      commit('SET_LOADING', false);
    }
  }, 

  // 관리자 답변 생성
  async createQaComment({ commit, rootState }, qaCommentData) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      console.log(qaCommentData);
      const response = await api.post(`/api/v1/communication/saveQaComment`, qaCommentData);
      commit('ADD_QA_COMMENT', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create QA:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        commit('SET_ERROR', `Failed to create QA: ${JSON.stringify(error.response.data)}`);
      } else {
        commit('SET_ERROR', error.message || 'Failed to create QA');
      }
      return {
        success: false,
        error: error.response ? error.response.data : (error.message || 'Failed to create QA')
      };
    } finally {
      commit('SET_LOADING', false);
    }
  },


};

const getters = {
  allQalist: state => state.qalist,
  qaDetail: state => state.qaDetail, // QA 상세 정보 가져오는 게터 추가
  qaComment: state => state.qaComment, 
  isLoading: state => state.isLoading,
  error: state => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
